module.exports = __webpack_public_path__ + "img/Billedbog_Barndommen_gjoer_inntog_i_boekene.2d795ec0.jpg";